module.exports = __webpack_public_path__ + "img/welcome_bg_new.083a9078.svg";